export class RqErrorLog {
    message: string;
    verificationId?: string;
    url: string;

    constructor(message: string, verificationId: string | undefined, url: string) {
        this.message = message;
        this.verificationId = verificationId;
        this.url = url;
    }
}